const getActionLabelColor = (token = {}) =>
    token.moduleMenuItemColor ?? token.colorTextLightSolid ?? '#ffffff';

/** Nút Lưu / Quay lại **trong thân Card** — bodyBg để tách khỏi nền card. */
export function getFormCardActionButtonTokens(token = {}) {
    const backgroundColor =
        token.bodyBg ?? token.colorBgLayout ?? token.moduleMenuBg ?? token.colorPrimary;
    const color = getActionLabelColor(token);
    return {
        backgroundColor,
        borderColor: backgroundColor,
        color,
    };
}

/** Nút **ngoài Card** (layout) + header card — moduleMenuBg, không trùng bodyBg. */
export function getPageActionButtonTokens(token = {}) {
    const backgroundColor = token.moduleMenuBg ?? token.colorPrimary;
    const color = getActionLabelColor(token);
    return {
        backgroundColor,
        borderColor: backgroundColor,
        color,
    };
}

export function getFormCardActionButtonStyle(token = {}) {
    return getFormCardActionButtonTokens(token);
}

export function getPageActionButtonStyle(token = {}) {
    return getPageActionButtonTokens(token);
}

export function getFormCardActionButtonCssVars(token = {}) {
    const { backgroundColor, color } = getFormCardActionButtonTokens(token);
    return {
        '--detail-theme-action-in-card-bg': backgroundColor,
        '--detail-theme-action-in-card-color': color,
    };
}

export function getPageActionButtonCssVars(token = {}) {
    const { backgroundColor, color } = getPageActionButtonTokens(token);
    return {
        '--detail-theme-action-bg': backgroundColor,
        '--detail-theme-action-color': color,
    };
}

/** @deprecated — dùng getFormCardActionButtonStyle (trong Card) hoặc getPageActionButtonStyle (ngoài Card) */
export function getDetailThemeActionTokens(token = {}) {
    return getFormCardActionButtonTokens(token);
}

/** @deprecated */
export function getDetailThemeActionCssVars(token = {}) {
    return getFormCardActionButtonCssVars(token);
}

/** @deprecated */
export function getDetailThemeActionButtonStyle(token = {}) {
    return getFormCardActionButtonStyle(token);
}
